import React from "react";
import i18n from "i18next";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import ConfirmBody from "@/react-components/Confirm/Body";
import ConfirmDiffBody from "@/react-components/Confirm/DiffBody";
import ConfirmUpdateTips from "@/react-components/Confirm/Update/Tips";
import { agreementStatusEnum } from "@/utils/enum";

class ConfirmUpdatePolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null, isFuture: false };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.agreement
      .getLoginPrivacyPolicy({ isSubUser: false })
      .then((response) => {
        if (response?.list && response?.list?.length > 0) {
          this.setState(
            {
              data: {
                content: response?.list[0],
                secureToken: response?.secureToken,
              },
            },
            () => {
              this.fetchTime();
            }
          );
        } else {
          const { updateStatus } = this.props;
          updateStatus && updateStatus(agreementStatusEnum.policyUpdated);
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchTime = () => {
    const { data } = this.state;
    const content = data?.content;
    if (content) {
      api.common
        .getTime()
        .then((response) => {
          const isFuture =
            moment(content.updateDate).format("YYYYMMDD") >
            moment(response).format("YYYYMMDD");
          const { updateStatus } = this.props;
          updateStatus &&
            updateStatus(agreementStatusEnum.policyWillUpdate, isFuture);
          this.setState({ isFuture });
        })
        .catch((error) => {
          console.error("error: " + error.message);
        });
    }
  };

  next = () => {
    const { data } = this.state;
    const { authentication } = this.props;
    const content = data?.content;
    api.agreement
      .updateLoginPrivacyPolicy({
        userid: authentication?.accountId,
        secureToken: data?.secureToken,
        version: content?.version,
      })
      .then((response) => {
        const { updateStatus } = this.props;
        updateStatus && updateStatus(agreementStatusEnum.policyUpdated);
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  close = () => {
    const { updateStatus } = this.props;
    updateStatus && updateStatus(agreementStatusEnum.policyUpdated);
  };

  header = () => {
    const { isFuture, data } = this.state;
    const content = data?.content;
    return (
      <ConfirmUpdateTips
        className="confirm-update-policy-container-tips"
        text={
          isFuture
            ? moment(content.updateDate).format(
                i18n.t("TCCs0021_confirm_update_policy_future_tips")
              )
            : i18n.t("TCCs0021_confirm_update_policy_tips")
        }
      />
    );
  };

  render() {
    const { data, isFuture } = this.state;
    const content = data?.content;
    return (
      <div className="confirm-update-policy-container">
        {this.header()}
        {content ? (
          <React.Fragment>
            <ConfirmDiffBody
              className="confirm-update-policy-container-diff-body"
              title={i18n.t("TCCs0021_confirm_update_policy_diff_title")}
              data={content}
              showExpand={true}
              // 課金-ADD-START
              downloadUrl={i18n.t("privacy_policy_diff_version_download_url")}
              // 課金-ADD-END
            />
            <ConfirmBody
              className="confirm-update-policy-container-body"
              title={i18n.t("TCCs0021_confirm_update_policy_content_title")}
              confirmButtonText={i18n.t(
                "TCCs0021_confirm_update_policy_button_title"
              )}
              content={content?.contentText}
              onClick={this.next}
              // 課金-ADD-START
              date={moment(content.updateDate).format(
                i18n.t("common_date_after")
              )}
              downloadUrl={i18n.t(
                "privacy_policy_applicable_version_download_url"
              )}
              // 課金-ADD-END
              showCheckbox={false}
              showCloseButton={isFuture}
              onClose={this.close}
            />
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

ConfirmUpdatePolicy.propTypes = {
  updateStatus: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    authentication: state?.user?.authentication,
  };
};

export default connect(mapStateToProps)(ConfirmUpdatePolicy);
